// src/pages/Prophets.tsx
import React, { useState } from 'react';
import DonationSidebar from '../components/DonationSidebar';

const Prophets: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'list' | 'tree'>('list');

  const prophetsData = [
    { number: 1, english: 'Adam', arabic: 'آدم', transliteration: 'Ādam', knownFor: 'First man and first Prophet; created by Allah', reference: 'Qur\'an 2:30–37' },
    { number: 2, english: 'Idris (Enoch)', arabic: 'إدريس', transliteration: 'Idrīs', knownFor: 'Among earliest prophets; known for knowledge and truth', reference: 'Qur\'an 19:56–57' },
    { number: 3, english: 'Nuh (Noah)', arabic: 'نوح', transliteration: 'Nūḥ', knownFor: 'Warned his people before the Great Flood', reference: 'Qur\'an 11:25–48' },
    { number: 4, english: 'Hud', arabic: 'هود', transliteration: 'Hūd', knownFor: 'Sent to the people of ‘Ād', reference: 'Qur\'an 11:50–60' },
    { number: 5, english: 'Saleh', arabic: 'صالح', transliteration: 'Ṣāliḥ', knownFor: 'Sent to the people of Thamūd; miracle of the she-camel', reference: 'Qur\'an 7:73–79' },
    { number: 6, english: 'Ibrahim (Abraham)', arabic: 'إبراهيم', transliteration: 'Ibrāhīm', knownFor: 'Father of Prophets; tested with sacrifice; built Ka\'bah', reference: 'Qur\'an 2:124–132' },
    { number: 7, english: 'Lut (Lot)', arabic: 'لوط', transliteration: 'Lūṭ', knownFor: 'Preached against sin to people of Sodom and Gomorrah', reference: 'Qur\'an 7:80–84' },
    { number: 8, english: 'Isma\'il (Ishmael)', arabic: 'إسماعيل', transliteration: 'Ismā‘īl', knownFor: 'Son of Ibrahim; helped build Ka\'bah; model of patience', reference: 'Qur\'an 19:54' },
    { number: 9, english: 'Ishaq (Isaac)', arabic: 'إسحاق', transliteration: 'Isḥāq', knownFor: 'Son of Ibrahim; father of Yaqub', reference: 'Qur\'an 11:71–73' },
    { number: 10, english: 'Yaqub (Jacob)', arabic: 'يعقوب', transliteration: 'Ya‘qūb', knownFor: 'Also known as Israel; father of the 12 tribes', reference: 'Qur\'an 12:6' },
    { number: 11, english: 'Yusuf (Joseph)', arabic: 'يوسف', transliteration: 'Yūsuf', knownFor: 'Son of Yaqub; known for beauty and patience', reference: 'Qur\'an 12:4–101' },
    { number: 12, english: 'Ayyub (Job)', arabic: 'أيوب', transliteration: 'Ayyūb', knownFor: 'Known for patience during severe trials', reference: 'Qur\'an 21:83–84' },
    { number: 13, english: 'Shu\'aib (Jethro)', arabic: 'شعيب', transliteration: 'Shu‘ayb', knownFor: 'Sent to people of Madyan; preached fair trade', reference: 'Qur\'an 7:85–93' },
    { number: 14, english: 'Musa (Moses)', arabic: 'موسى', transliteration: 'Mūsā', knownFor: 'Freed Israelites from Pharaoh; received Tawrah (Torah)', reference: 'Qur\'an 20:9–98' },
    { number: 15, english: 'Harun (Aaron)', arabic: 'هارون', transliteration: 'Hārūn', knownFor: 'Brother and helper of Musa; shared prophethood', reference: 'Qur\'an 20:30–36' },
    { number: 16, english: 'Dhul-Kifl (Ezekiel or Isaiah)', arabic: 'ذو الكفل', transliteration: 'Dhul-Kifl', knownFor: 'Known for steadfastness and righteousness', reference: 'Qur\'an 21:85' },
    { number: 17, english: 'Dawud (David)', arabic: 'داوود', transliteration: 'Dāwūd', knownFor: 'King and Prophet; given Zabur (Psalms)', reference: 'Qur\'an 38:17–26' },
    { number: 18, english: 'Sulayman (Solomon)', arabic: 'سليمان', transliteration: 'Sulaymān', knownFor: 'Son of Dawud; known for wisdom and control over jinn', reference: 'Qur\'an 27:15–44' },
    { number: 19, english: 'Ilyas (Elijah)', arabic: 'إلياس', transliteration: 'Ilyās', knownFor: 'Called people away from idol Ba\'al worship', reference: 'Qur\'an 37:123–132' },
    { number: 20, english: 'Al-Yasa (Elisha)', arabic: 'اليسع', transliteration: 'Al-Yasa‘', knownFor: 'Successor of Ilyas; continued his mission', reference: 'Qur\'an 38:48' },
    { number: 21, english: 'Yunus (Jonah)', arabic: 'يونس', transliteration: 'Yūnus', knownFor: 'Swallowed by the whale; repented sincerely', reference: 'Qur\'an 37:139–148' },
    { number: 22, english: 'Zakariya (Zechariah)', arabic: 'زكريا', transliteration: 'Zakariyyā', knownFor: 'Father of Yahya; guardian of Maryam', reference: 'Qur\'an 19:2–15' },
    { number: 23, english: 'Yahya (John the Baptist)', arabic: 'يحيى', transliteration: 'Yaḥyā', knownFor: 'Son of Zakariya; known for purity', reference: 'Qur\'an 19:12–15' },
    { number: 24, english: 'Isa (Jesus)', arabic: 'عيسى', transliteration: '‘Īsā', knownFor: 'Born miraculously to Maryam; given Injil (Gospel)', reference: 'Qur\'an 3:45–52, 19:30–36' },
    { number: 25, english: 'Muhammad', arabic: 'محمد', transliteration: 'Muḥammad ﷺ', knownFor: 'Final Prophet; received the Qur\'an; mercy to mankind', reference: 'Qur\'an 33:40, 21:107' }
  ];

  const renderProphetsList = () => (
    <div className="card">
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: 'var(--bg-secondary)' }}>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>No.</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>Prophet Name</th>
              <th style={{ padding: '12px', textAlign: 'right', borderBottom: '1px solid var(--border)' }}>Arabic</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>Transliteration</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>Known For</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>Qur'an Reference</th>
            </tr>
          </thead>
          <tbody>
            {prophetsData.map((prophet) => (
              <tr key={prophet.number} style={{ borderBottom: '1px solid var(--border)' }}>
                <td style={{ padding: '12px', fontWeight: '600', color: 'var(--accent-primary)' }}>{prophet.number}</td>
                <td style={{ padding: '12px', fontWeight: '600', color: 'var(--text-primary)' }}>{prophet.english}</td>
                <td style={{ padding: '12px', textAlign: 'right', direction: 'rtl', fontFamily: "'Amiri', serif", fontSize: '18px' }}>
                  {prophet.arabic}
                </td>
                <td style={{ padding: '12px', color: 'var(--text-secondary)', fontStyle: 'italic' }}>{prophet.transliteration}</td>
                <td style={{ padding: '12px', color: 'var(--text-secondary)' }}>{prophet.knownFor}</td>
                <td style={{ padding: '12px', color: 'var(--accent-primary)', fontSize: '14px' }}>{prophet.reference}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderFamilyTree = () => (
    <div className="card">
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h3 style={{ color: 'var(--text-primary)', marginBottom: '16px' }}>🌳 The Family Tree of the Prophets</h3>
        <p style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
          Based on Qur'an, Sahih Hadith, and major Tafsir like Ibn Kathir
        </p>
      </div>

      {/* Interactive Family Tree Visualization */}
      <div style={{ 
        backgroundColor: 'var(--bg-secondary)', 
        padding: '32px', 
        borderRadius: '12px',
        border: '1px solid var(--border)',
        overflowX: 'auto'
      }}>
        <div style={{ minWidth: '800px', fontFamily: 'monospace', lineHeight: '2', color: 'var(--text-primary)' }}>
          
          {/* Adam Line */}
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <strong>Ādam عليه السلام</strong>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Wife: Ḥawwā (Eve)</div>
          </div>

          <div style={{ textAlign: 'center', margin: '20px 0' }}>↓</div>

          {/* Sheeth Line */}
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <strong>Sheeth</strong>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Son of Ādam</div>
          </div>

          <div style={{ textAlign: 'center', margin: '20px 0' }}>↓</div>

          {/* Idris Line */}
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <strong>Idrīs عليه السلام</strong>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Descendant of Sheeth</div>
          </div>

          <div style={{ textAlign: 'center', margin: '20px 0' }}>↓</div>

          {/* Nuh Line */}
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <strong>Nūḥ عليه السلام</strong>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Descendant of Idrīs</div>
          </div>

          {/* Nuh's Children */}
          <div style={{ display: 'flex', justifyContent: 'space-around', margin: '30px 0' }}>
            <div style={{ textAlign: 'center' }}>
              <div>Hūd عليه السلام</div>
              <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>People of 'Ād</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div>Ṣāliḥ عليه السلام</div>
              <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>People of Thamūd</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <strong>Ibrāhīm عليه السلام</strong>
              <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Father of Prophets</div>
            </div>
          </div>

          {/* Ibrahim's Lineage */}
          <div style={{ textAlign: 'center', margin: '20px 0' }}>
            <strong>Ibrāhīm عليه السلام</strong>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
              Wives: Sārah (mother of Ishāq), Hājar (mother of Ismā'īl)
            </div>
          </div>

          {/* Two Main Branches */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', marginTop: '30px' }}>
            
            {/* Ismail Line - Arab Prophets */}
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontWeight: 'bold', color: 'var(--accent-primary)', marginBottom: '15px' }}>
                From Ismā'īl عليه السلام
              </div>
              <div>Ismā'īl عليه السلام</div>
              <div style={{ margin: '10px 0' }}>↓</div>
              <div style={{ fontWeight: 'bold' }}>Arab Tribes</div>
              <div style={{ margin: '10px 0' }}>↓</div>
              <div style={{ fontWeight: 'bold', color: 'var(--accent-primary)' }}>Muḥammad ﷺ</div>
              <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Final Prophet</div>
            </div>

            {/* Ishāq Line - Bani Israel Prophets */}
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontWeight: 'bold', color: 'var(--accent-primary)', marginBottom: '15px' }}>
                From Ishāq عليه السلام
              </div>
              <div>Ishāq عليه السلام</div>
              <div style={{ margin: '10px 0' }}>↓</div>
              <div>Ya'qūb عليه السلام (Israel)</div>
              <div style={{ margin: '10px 0' }}>↓</div>
              
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginTop: '10px' }}>
                <div>
                  <div>Yūsuf عليه السلام</div>
                  <div>Mūsā عليه السلام</div>
                  <div>Hārūn عليه السلام</div>
                  <div>Dāwūd عليه السلام</div>
                </div>
                <div>
                  <div>Sulaymān عليه السلام</div>
                  <div>Zakariyyā عليه السلام</div>
                  <div>Yaḥyā عليه السلام</div>
                  <div>'Īsā عليه السلام</div>
                </div>
              </div>
            </div>
          </div>

          {/* Key Relationships */}
          <div style={{ 
            marginTop: '40px', 
            padding: '20px', 
            backgroundColor: 'var(--bg-primary)',
            borderRadius: '8px',
            border: '1px solid var(--border)'
          }}>
            <h4 style={{ textAlign: 'center', marginBottom: '15px', color: 'var(--text-primary)' }}>
              Key Relationships
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', fontSize: '14px' }}>
              <div>
                <strong>Father-Son:</strong>
                <div>Ibrāhīm → Ismā'īl & Ishāq</div>
                <div>Ishāq → Ya'qūb</div>
                <div>Ya'qūb → Yūsuf</div>
                <div>Dāwūd → Sulaymān</div>
                <div>Zakariyyā → Yaḥyā</div>
              </div>
              <div>
                <strong>Brothers:</strong>
                <div>Mūsā & Hārūn</div>
                <div>Ismā'īl & Ishāq</div>
              </div>
              <div>
                <strong>Successors:</strong>
                <div>Ilyās → Al-Yasa'</div>
                <div>Mūsā → Yūsha' (Joshua)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ 
        marginTop: '32px', 
        padding: '20px', 
        backgroundColor: 'var(--bg-secondary)',
        borderRadius: '8px',
        border: '1px solid var(--border)'
      }}>
        <h4 style={{ color: 'var(--text-primary)', marginBottom: '12px' }}>🧭 Summary of Major Prophet Connections</h4>
        <div style={{ fontFamily: 'monospace', lineHeight: '1.6', color: 'var(--text-secondary)' }}>
          Ādam<br/>
          &nbsp;└── Sheeth<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└── Idrīs<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└── Nūḥ<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;├── Hūd → (People of 'Ād)<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;├── Ṣāliḥ → (People of Thamūd)<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└── Ibrāhīm<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;├── Ismā'īl → Muḥammad ﷺ<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└── Ishāq<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└── Ya'qūb (Israel)<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;├── Yūsuf<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;├── Mūsā ─ Hārūn<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;├── Dāwūd ─ Sulaymān<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;├── Zakariyyā ─ Yaḥyā<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└── 'Īsā (via Maryam)
        </div>
      </div>
    </div>
  );

  return (
    <div className="section-padding">
      <div className="container">
        <div className="section-title">
          <h1>Prophets of Islam</h1>
          <p>Learn about the 25 prophets mentioned in the Quran and their family relationships</p>
        </div>

        {/* Navigation Tabs */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '40px',
          borderBottom: '1px solid var(--border)',
          flexWrap: 'wrap',
          gap: '8px'
        }}>
          <button
            onClick={() => setActiveTab('list')}
            style={{
              padding: '12px 24px',
              border: 'none',
              backgroundColor: activeTab === 'list' ? 'var(--accent-primary)' : 'transparent',
              color: activeTab === 'list' ? 'var(--bg-primary)' : 'var(--text-secondary)',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              borderBottom: activeTab === 'list' ? '2px solid var(--accent-primary)' : 'none',
              borderRadius: '8px 8px 0 0'
            }}
          >
            📋 Prophets List
          </button>
          <button
            onClick={() => setActiveTab('tree')}
            style={{
              padding: '12px 24px',
              border: 'none',
              backgroundColor: activeTab === 'tree' ? 'var(--accent-primary)' : 'transparent',
              color: activeTab === 'tree' ? 'var(--bg-primary)' : 'var(--text-secondary)',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              borderBottom: activeTab === 'tree' ? '2px solid var(--accent-primary)' : 'none',
              borderRadius: '8px 8px 0 0'
            }}
          >
            🌳 Family Tree
          </button>
        </div>

        {/* Content */}
        {activeTab === 'list' ? renderProphetsList() : renderFamilyTree()}

        <DonationSidebar />
      </div>
    </div>
  );
};

export default Prophets;